import {Injectable} from '@angular/core';
import {
    STORAGE_CYCLE_LIST, STORAGE_CYCLE_TITLE,
    STORAGE_CYCLE_PDFLINK,
    STORAGE_IFRAME_PARAMS,
    STORAGE_TOKEN_NAME,
    STORAGE_USER_NAME, STORAGE_CYCLE_LIST_TITLE, STORAGE_SESSIONID_NAME, APP_NAVIGATION_CALL
} from '../../../environments/environment';
import {ApiService} from '../api-service/api.service';
import {ErrorService} from '../error-service/error.service';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    
    constructor(private api: ApiService,
                private error: ErrorService) {
    }
    
    setToken(token: string) {
        localStorage.setItem(STORAGE_TOKEN_NAME, token);
    }

    setSessionId(sessionId: string) {
        if (sessionId === '') {
            localStorage.removeItem(STORAGE_SESSIONID_NAME);
        } else {
            localStorage.setItem(STORAGE_SESSIONID_NAME, sessionId);
        }
    }
    
    getToken(): string {
        const token = localStorage.getItem(STORAGE_TOKEN_NAME);
        if (token) {
            return token;
        } else {
            this.error.redirectLogin();
        }
    }

    getSessionId(): string {
        const sessionId = localStorage.getItem(STORAGE_SESSIONID_NAME);
        if (sessionId) {
            return sessionId;
        }
        return '';
    }
    
    setCyleList(list: Array<number>) {
        
        const cycleList = [];
        const cycleName = [];
        const cyclePDFLinks = [];
        
        list.forEach((item) => {
            cycleList.push(item['number']);
            cycleName.push(item['title']);
            cyclePDFLinks.push(item['pdfUrl']);
        });
        
        localStorage.setItem(STORAGE_CYCLE_LIST, JSON.stringify(cycleList));
        localStorage.setItem(STORAGE_CYCLE_TITLE, JSON.stringify(cycleName));
        localStorage.setItem(STORAGE_CYCLE_PDFLINK, JSON.stringify(cyclePDFLinks));
    }
    
    setCycleListTitle(title: string) {
        localStorage.setItem(STORAGE_CYCLE_LIST_TITLE, title);
    }
    
    getCycleListTitle(): string {
        return localStorage.getItem(STORAGE_CYCLE_LIST_TITLE);
    }
    
    getCycleList(): Array<number> {
        return JSON.parse(localStorage.getItem(STORAGE_CYCLE_LIST));
    }
    
    getCycleTitles(): Array<number> {
        return JSON.parse(localStorage.getItem(STORAGE_CYCLE_TITLE));
    }
    
    getCyclePDFLinks(): Array<string> {
        return JSON.parse(localStorage.getItem(STORAGE_CYCLE_PDFLINK));
    }
    
    setUsername(username: string) {
        localStorage.setItem(STORAGE_USER_NAME, username);
    }
    
    getUsername(): string {
        const username = localStorage.getItem(STORAGE_USER_NAME);
        if (username) {
            return username;
        } else {
            return '';
        }
    }
    
    setIframeParams(parameterString): void {
        localStorage.setItem(STORAGE_IFRAME_PARAMS, parameterString);
    }
    
    getIframeParams(): string {
        return localStorage.getItem(STORAGE_IFRAME_PARAMS);
    }

    setNavigationCall(route: string): void {
        localStorage.setItem(APP_NAVIGATION_CALL, route);
    }

    getNavigationCall(): string {
        return localStorage.getItem(APP_NAVIGATION_CALL);
    }

    removeNavigationCall() {
        localStorage.removeItem(APP_NAVIGATION_CALL)
    }
}
